import React from 'react';
import ProductCard from './ProductCard';

const ProductSection = ({ title, subtitle, products, categoryId, bgColor = "bg-white" }) => {
  return (
    <section id={`category-${categoryId}`} className={`py-20 ${bgColor}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-4">{title}</h2>
          <p className="text-lg text-gray-600 max-w-3xl">{subtitle}</p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductSection;
